import { render, staticRenderFns } from "./LoadingForm.vue?vue&type=template&id=752603f6&"
import script from "./LoadingForm.vue?vue&type=script&lang=js&"
export * from "./LoadingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports